import React from 'react';
import { createContainer } from 'unstated-next';

const useSetActiveDropTarget = () => {
    const [dropTarget, setDropTarget] = React.useState();
    return { dropTarget, setDropTarget };
};

export const ActiveDropTarget = createContainer(useSetActiveDropTarget);
